<template>
  <div class="outer-wrapper">
    <van-nav-bar
        :title="'项目接收('+projectDisplayNoAbbr(project_display_no)+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickBack"
        fixed
      ></van-nav-bar>
    <div class="nothing" v-if="!Boolean(totalInsList.length+totalReportList.length)">
      <p>{{nothingText}}</p>
    </div>
    <div class="sample-list">
      <van-checkbox-group v-model="selectedName" ref="checkboxGroup">
        <div class="sample" v-for="sam in project.sampleList" :key="sam.sampleId+'s'">
          <div class="sample-title">
            <img :src="sam.img" alt style="height:2rem;"/>
            <div style="font-size:0.6rem;over-flow:hidden;">{{sam.sampleName}}{{sam.sampleDisplayNo?'('+sampleDisplayNoAbbr(sam.sampleDisplayNo)+')':''}}</div>
          </div>
          <div class="ins ele-list" v-for="ins in sam.insList" :key="ins.id+'in'">
            <p>
              <van-checkbox
                :name="ins.id+'-ins'"
                shape="square"
                checked-color="#07c160"
                :disabled="Boolean(ins.owner)"
              >
                {{ins.product_name+"("+ins.sub_choice+")"}}
                <span v-if="Boolean(ins.owner)" class="owner-name">(已被接收---{{ins.owner_name}})</span>
              </van-checkbox>
            </p>
          </div>
          <div class="report ele-list" v-for="report in sam.reportList" :key="report.id+'re'">
            <p>
              <van-checkbox
                :name="report.id+'-report'"
                shape="square"
                checked-color="#07c160"
                :disabled="Boolean(report.owner)"
              >
                编制报告：{{report.display_no}}
                <span v-if="Boolean(report.owner)" class="owner-name">(已被接收---{{report.owner_name}})</span>
              </van-checkbox>
            </p>
          </div>
        </div>
        <div class="sep-report ele-list" v-if="project.report.id">
          <p>
            <van-checkbox
              :name="project.report.id+'-report'"
              shape="square"
              checked-color="#07c160"
              :disabled="Boolean(project.report.owner)"
            >
              编制报告：{{project.report.display_no}}
              <span
                v-if="Boolean(project.report.owner)"
                class="owner-name"
              >(已被接收---{{project.report.owner_name}})</span>
            </van-checkbox>
          </p>
        </div>
      </van-checkbox-group>
    </div>
    <div class="submit-box">
      <van-checkbox
        v-model="choosedAll"
        checked-color="#ee0a24"
        class="selectBox"
        @click="toggleAll"
        :disabled="!Boolean(validListNumber)"
      >全选</van-checkbox>
      <button class="submit" @click.once="submit">提交已选</button>
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
let authData = localStorage.getItem("authData");
import { textTrans } from "@/mixins/TextTrans.js";

function sampleDoFac() {
  return {
    sampleId: 0,
    sampleName: "",
    img: "",
    material: "",
    customerModel: "",
    otherProperty: "",
    insList: [],
    reportList: []
  };
}

export default {
  name: "sampleReceive",
  components: {},
  mixins: [textTrans],
  props: {
    project_display_no: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      project: {
        display_no: "",
        id: 0,
        sampleList: [],
        reportMerge: "",
        report: {} //项目只出一份报告时，此项内赋值
      },
      totalInsList: [],
      totalReportList: [],
      nothingText: "",
      choosedAll: false,
      sampleDo: sampleDoFac(),
      selectedName: [],
    };
  },
  watch: {
    choosedAll: {
      deep: true,
      handler: function() {
        setTimeout(this.checkDisabled, 50);
      }
    }
  },
  computed: {
    validListNumber: function() {
      let tmp = 0;
      for (let ele of this.totalReportList) {
        if (!ele.owner) {
          tmp++;
        }
      }
      for (let ele of this.totalInsList) {
        if (!ele.owner) {
          tmp++;
        }
      }
      return tmp;
    },
    selected: function() {
      let ins = [];
      let report = [];
      for (let ele of this.selectedName) {
        if (ele.split("-")[1] === "ins") {
          ins.push(this.totalInsList.find(val => val.id == ele.split("-")[0]));
        } else if (ele.split("-")[1] === "report") {
          report.push(
            this.totalReportList.find(val => val.id == ele.split("-")[0])
          );
        }
      }
      return {
        ins: ins,
        report: report
      };
    },
  },
  created() {
    if(this.project_display_no){
      this.getInsData();
    }
    if (authData) {
      this.sfileRight = JSON.parse(authData).sfileRight;
    } else {
      this.sfileRight = "";
    }
  },
  methods: {
    getInsData() {
      this.$axios
        .post(this.$url + "/ask_option_data", {
          userToken: userToken,
          ask_data: "projectReceive",
          project_display_no: this.project_display_no
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.project.id = response.data.projectId;
            this.project.display_no = this.project_display_no;
            this.project.reportMerge = response.data.reportMerge;
            this.totalInsList = response.data.insList;
            this.totalReportList = response.data.reportList;
            if (
              response.data.reportList.length === 0 &&
              response.data.insList.length === 0
            ) {
              this.nothingText =
                "业务管理部门还未收到委托单" +
                this.project_display_no +
                "所涉及的样品或上述样品还未进行核对!";
            }else{
            let tmp = -1;
            let tmpSample = null;
            for (let ele of response.data.insList) {
              tmp = this.project.sampleList.findIndex(
                val => val.sampleId === ele.sample_id
              );
              if (tmp !== -1) {
                this.project.sampleList[tmp].insList.push(ele);
              } else {
                tmpSample = sampleDoFac();
                tmpSample.sampleId = ele.sample_id;
                tmpSample.sampleDisplayNo = ele.sample_display_no;
                tmpSample.sampleName = ele.sample_name;
                if (ele.sample_img) {
                  tmpSample.img = this.$fileUrlFac(
                    JSON.parse(ele.sample_img).urlList[0],
                    this.sfileRight
                  );
                }
                tmpSample.material = ele.material;
                tmpSample.customerModel = ele.customer_model;
                tmpSample.otherProperty = ele.other_property;
                tmpSample.insList.push(ele);
                this.project.sampleList.push(tmpSample);
              }
            }
            for (let ele of response.data.reportList) {
              tmp = this.project.sampleList.findIndex(
                val => val.sampleId == ele.sample_id
              );
              if (tmp !== -1) {
                this.project.sampleList[tmp].reportList.push(ele);
              } else {
                this.project.report = ele;
              }
            }
            }
          } else if (response.data.stat === "projectCancel") {
            this.nothingText = "委托单" + this.project_display_no + "已被取消!";
          } else if (response.data.stat === "testComplete") {
            this.nothingText = "委托单" + this.project_display_no + "已完成!";
          } else {
            this.$Message.error(response.data.error_info);
          }
        });
    },
    toggleAll() {
      if (this.validListNumber) {
        this.$refs.checkboxGroup.toggleAll(!this.choosedAll);
      }
    },
    checkDisabled() {
      if (this.selectedName.length > 0) {
        let tmp = [];
        for (let ele of this.selectedName) {
          if (ele.split("-")[1] === "ins") {
            if (
              !this.totalInsList.find(val => val.id == ele.split("-")[0]).owner
            ) {
              tmp.push(ele);
            }
          } else if (ele.split("-")[1] === "report") {
            if (
              !this.totalReportList.find(val => val.id == ele.split("-")[0])
                .owner
            ) {
              tmp.push(ele);
            }
          }
        }
        this.selectedName = tmp;
      }
    },
    changeRadio() {
      this.sampleDo.changeFlag = true;
    },
    submit() {
      if (this.selected.report.length + this.selected.ins.length > 0) {
        this.$axios
          .post(this.$url + "/inspection_do", {
            userToken: userToken,
            askData: "projectReceive",
            project_id: this.project.id,
            selected: this.selected
          })
          .then(response => {
            if (response.data.stat === "ok") {
              window.location.reload();
            } else {
              this.$toast.fail('接收失败!');
            }
          });
      }
    },
    handleSelectAll(status, refid) {
      this.$refs[refid].selectAll(status);
    },
    chooseProject(valueList) {
      this.selected.report = [];
      this.selected.ins = [];
      for (let ele of valueList) {
        if (ele.type === "report") {
          this.selected.report.push(ele);
        } else if (ele.type === "ins") {
          this.selected.ins.push(ele);
        }
      }
    },
    onClickBack(){
      window.location.href="/projectReceive";
    }
  }
};
</script>
<style scoped>
.title-box p {
  font-size: 0.8rem;
  text-align: center;
  color: brown;
  font-weight: 700;
}
.submit-box {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.selectBox {
  float: left;
  margin-top: 0.6rem;
  margin-left: 0.6rem;
}

.submit-box button {
  background: #ee0a24;
  color: #fff;
  height: 2.2rem;
  line-height: 2.2rem;
  width: 8rem;
  float: right;
  outline: none;
  border: none;
}

.ele-list {
  padding: 0.8rem 1rem 0;
  font-size: 0.6rem;
}
.ele-list p {
  position: relative;
}

.sample-title {
  height: 2.0rem;
  line-height: 2.5rem;
  display: flex;
  font-size: 0.8rem;
  margin: 0 1rem;
  border-bottom: 1px solid #eee;
}

.sample-title img {
  height: 2.2rem;
  margin: 0 1rem;
}

.sample,
.sep-report {
  margin-top:0.5rem;
}

.ele-list:last-child {
  border-bottom: 1px solid #c0c0c0;
  padding-bottom: 0.8rem;
}

.nothing {
  padding: 1rem 3rem;
  font-size: 0.6rem;
  text-indent: 1.2rem;
  line-height: 1.2rem;
}

.owner-name {
  font-weight: 700;
}
.sample-list{
  padding-top:0.3rem; 
  padding-bottom:3rem; 
}
</style>
